<template>
  <div>
    <v-card class="ma-3" v-if="profile" flat>
      <v-card-title class="p-0">
        <p class="m-0 font-weight-bold">
          Customer ID:
          <span class=""> {{ profile.master_customer_id }} </span>
        </p>
        <v-spacer></v-spacer>

        <v-btn depressed color="primary" text @click="EditProfileData(profile)">
          Edit <v-icon small>mdi-pencil-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="p-0 m-0"></v-divider>
      <v-card-text class="mt-2">
        <v-row class="d-flex justify-space-around">
          <v-col class="mt-4" cols="12" md="12" lg="12">
            <v-row>
              <table>
                <tbody>
                  <tr>
                    <td>Entity Type</td>
                    <td>
                      <b>{{
                        profile &&
                        profile.entity_type &&
                        profile.entity_type.value
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Name Of the Company</td>
                    <td>
                      <b>{{ profile && profile.business_name }}</b>
                    </td>
                  </tr>

                  <tr>
                    <td>Registration No</td>
                    <td>
                      <b>{{ profile && profile.registration_number }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Date of Incorporation</td>
                    <td>
                      <b>{{ profile && profile.dob }} </b>
                    </td>
                  </tr>
                  <tr>
                    <td>Source of Fund</td>
                    <td>
                      <b>{{
                        profile &&
                        profile.source_of_fund_code &&
                        profile.source_of_fund_code.value
                      }}</b>
                    </td>
                  </tr>

                  <tr>
                    <td>Nature Of Business</td>
                    <td>
                      <b>{{
                        profile &&
                        profile.nature_of_business &&
                        profile.nature_of_business.value
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Number</td>
                    <td>
                      <b>{{ profile && profile.phone_number }} </b>
                    </td>
                  </tr>
                  <tr>
                    <td>Business E-mail</td>
                    <td>
                      <b>{{ profile && profile.business_email }}</b>
                    </td>
                  </tr>

                  <tr>
                    <td>Corporate Address</td>
                    <td>
                      <b>{{ profile && profile.mailing_address }}</b>
                    </td>
                  </tr>
                  <tr
                    v-if="!profile.is_mailing_address_same_as_business_address"
                  >
                    <td>Business Address</td>
                    <td>
                      <b>{{ profile && profile.address }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-row>
          </v-col>
        </v-row>
        <br />
      </v-card-text>
    </v-card>
    <v-dialog persistent v-model="dialog">
      <v-card>
        <v-form ref="Addform" v-model="valid">
          <v-toolbar color="secondary" dark flat dense>
            Company Entity Details
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Entity Type
                </label>
                <v-autocomplete
                  v-model="editedProfile.entity_type"
                  :items="EntityTypes"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Entity Type"
                  :rules="FieldRequired('Entity Type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Name Of the Company
                </label>
                <v-text-field
                  v-model="editedProfile.business_name"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Name Of the Company "
                  :rules="FieldRequired('Name Of the Company ')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Registration Number
                </label>
                <v-text-field
                  class="rounded"
                  v-model="editedProfile.registration_number"
                  dense
                  outlined
                  placeholder="Registration Number"
                  :rules="FieldRequired('Registration Number')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Date of Incorporation
                </label>
                <v-text-field
                  v-model="editedProfile.dob"
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  :rules="FieldRequired('Date of Incorporation')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Source Of Fund
                </label>
                <v-autocomplete
                  :items="SourceOfFunds"
                  v-model="editedProfile.source_of_fund_code"
                  item-text="text"
                  item-value="value"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Source Of Fund "
                  :rules="FieldRequired('Source Of Fund ')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Nature Of Business
                </label>
                <v-autocomplete
                  :items="NatureOfBusiness"
                  v-model="editedProfile.nature_of_business"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Nature Of Business"
                  :rules="FieldRequired('Nature Of Business')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize"> Website </label>
                <v-text-field
                  v-model="editedProfile.website"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Website"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Contact Number
                </label>
                <v-text-field
                  v-model="editedProfile.phone_number"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Contact Number"
                  :rules="FieldRequired('Contact Number')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize">
                  Average Annual Turnover
                </label>
                <v-text-field
                  v-model="editedProfile.salary_range"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Average Annual Turnover"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Business E-mail
                </label>
                <v-text-field
                  v-model="editedProfile.business_email"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Business E-mail"
                  :rules="FieldRequired('Business E-mail')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Corporate Address
                </label>
                <v-text-field
                  v-model="editedProfile.mailing_address"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Corporate Address"
                  :rules="FieldRequired('Corporate Address')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Country
                </label>
                <v-autocomplete
                  :items="CountryOptions"
                  v-model="editedProfile.mailing_country"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country"
                  @change="getMailingStates(editedProfile.mailing_country)"
                  :rules="FieldRequired('Country')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  State
                </label>
                <v-autocomplete
                  :items="mailingStateOptions"
                  v-model="editedProfile.mailing_state"
                  class="rounded"
                  dense
                  outlined
                  placeholder="State"
                  @change="
                    getCities(
                      editedProfile.mailing_country,
                      editedProfile.mailing_state,
                      true
                    )
                  "
                  :rules="FieldRequired('State')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  City
                </label>
                <v-autocomplete
                  v-if="!mailingCityInputEnabled"
                  :items="cityOptions"
                  v-model="editedProfile.mailing_city"
                  class="rounded"
                  dense
                  outlined
                  placeholder="City"
                  :rules="FieldRequired('City')"
                ></v-autocomplete>
                <v-text-field
                  v-else
                  v-model="editedProfile.mailing_city"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Enter City"
                  :rules="FieldRequired('City')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Postal Code
                </label>
                <v-text-field
                  v-model="editedProfile.mailing_postal_code"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" Postal Code"
                  :rules="FieldRequired(' Postal Code')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch
                  v-model="
                    editedProfile.is_mailing_address_same_as_business_address
                  "
                  label="Same as a Business Address"
                  color="green"
                  inset
                  dense
                  class="ms-2 mt-0 m-auto"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="
                  !editedProfile.is_mailing_address_same_as_business_address
                "
              >
                <label class="my-0 rounded labelFontsize">
                  Street Number
                </label>
                <v-text-field
                  v-model="editedProfile.street_number"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Street Number"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="
                  !editedProfile.is_mailing_address_same_as_business_address
                "
              >
                <label class="my-0 rounded labelFontsize required">
                  Business Address
                </label>
                <v-text-field
                  v-model="editedProfile.address"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" Business Address"
                  :rules="
                    !editedProfile.is_mailing_address_same_as_business_address
                      ? FieldRequired('Business Address')
                      : []
                  "
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="
                  !editedProfile.is_mailing_address_same_as_business_address
                "
              >
                <label class="my-0 rounded labelFontsize required">
                  Country
                </label>
                <v-autocomplete
                  v-model="editedProfile.country_code"
                  :items="CountryOptions"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country"
                  @change="getStates(editedProfile.country_code)"
                  :rules="
                    !editedProfile.is_mailing_address_same_as_business_address
                      ? FieldRequired('Country')
                      : []
                  "
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="
                  !editedProfile.is_mailing_address_same_as_business_address
                "
              >
                <label class="my-0 rounded labelFontsize required">
                  State
                </label>
                <v-autocomplete
                  v-model="editedProfile.state_code"
                  :items="stateOptions"
                  class="rounded"
                  dense
                  outlined
                  placeholder="State"
                  @change="
                    getMailingCities(
                      editedProfile.country_code,
                      editedProfile.state_code,
                      true
                    )
                  "
                  :rules="
                    !editedProfile.is_mailing_address_same_as_business_address
                      ? FieldRequired('State')
                      : []
                  "
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="
                  !editedProfile.is_mailing_address_same_as_business_address
                "
              >
                <label class="my-0 rounded labelFontsize required">
                  City
                </label>
                <v-autocomplete
                  v-if="!businessCityInputEnabled"
                  v-model="editedProfile.city_code"
                  :items="mailingCityOptions"
                  class="rounded"
                  dense
                  outlined
                  placeholder="City"
                  :rules="
                    !editedProfile.is_mailing_address_same_as_business_address
                      ? FieldRequired('City')
                      : []
                  "
                ></v-autocomplete>
                <v-text-field
                  v-else
                  v-model="editedProfile.city_code"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Enter City"
                  :rules="FieldRequired('City')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="
                  !editedProfile.is_mailing_address_same_as_business_address
                "
              >
                <label class="my-0 rounded labelFontsize required">
                  Postal Code
                </label>
                <v-text-field
                  v-model="editedProfile.zip_code"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Postal Code"
                  :rules="
                    !editedProfile.is_mailing_address_same_as_business_address
                      ? FieldRequired('Postal Code')
                      : []
                  "
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="12 "
                v-if="
                  !editedProfile.is_mailing_address_same_as_business_address
                "
              >
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
              </v-col>

              <div
                class="col-md-12"
                style="display: flex; justify-content: right; margin-top: 8px"
              >
                <v-btn
                  depressed
                  color="primary"
                  min-width="170px"
                  class="me-5 text-capitalize"
                  @click="onSubmitFor()"
                >
                  Save
                </v-btn>

                <v-btn
                  depressed
                  color="primary"
                  class="text-capitalize"
                  outlined
                  min-width="170px"
                  @click="closeDialog()"
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                  >Cancel
                </v-btn>
              </div>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <OverlayPageVue :showOverlay="loader" />
  </div>
</template>
<script>
import alerts from "@/mixins/alerts";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { FieldRequired } from "@/utils/validation.js";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService";
import businessService from "@/services/BusinessService/businessService.js";
export default {
  name: "",
  mixins: [alerts],
  components: {
    OverlayPageVue,
  },

  // props: ["profile"],
  data() {
    return {
      FieldRequired,
      dialog: false,
      valid: true,
      loader: false,
      EntityTypes: [],
      SourceOfFunds: [],
      NatureOfBusiness: [],
      CountryOptions: [],
      stateOptions: [],
      mailingStateOptions: [],
      cityOptions: [],
      mailingCityOptions: [],
      mailingCityInputEnabled: false,
      businessCityInputEnabled: false,
      selectedProfileDetails: null,
      profile: {},
      editedProfile: {
        entity_type: "",
        registration_number: "",
        website: "",
        business_name: "",
        dob: "",
        salary_range: "",
        source_of_fund_code: "",
        nature_of_business: "",
        address: "",
        country_code: "",
        state_code: "",
        city_code: "",
        zip_code: "",
        is_mailing_address_same_as_business_address: true,
        mailing_address: "",
        street_number: "",
        mailing_postal_code: "",
        mailing_city: "",
        mailing_state: "",
        mailing_country: "",
        modified_by: "",
        modified_date: "",
        business_email: "",
        phone_number: "",
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getdropdowntypes("SOF");
    this.getdropdowntypes("NOB");
    this.getdropdowntypes("ETD");
    this.getcountryList();
    this.getBusinessInfoData();
  },
  methods: {
    async getBusinessInfoData() {
      this.loader = true;
      try {
        const responseData = await businessService.getentityInfo(
          this.$route.query.id
        );
        if (responseData.data.status_code === 200) {
          this.profile = responseData.data.data[0];
          console.log("BUS Profile", responseData.data);
          this.loader = false;
        } else {
          this.profile = {};
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        console.error(error);
        this.loader = false;
      }
    },
    async getBusinessInfo() {
      this.loader = true;
      try {
        const responseData = await businessService.getentityInfo(
          this.$route.query.id
        );
        if (responseData.data.status_code === 200) {
          const temp = { ...responseData.data.data[0] };
          this.editedProfile = temp;
          this.loader = false;
          this.editedProfile.entity_type =
            responseData.data.data[0].entity_type &&
            responseData.data.data[0].entity_type.value_code
              ? responseData.data.data[0].entity_type.value_code
              : null;
          this.editedProfile.nature_of_business =
            responseData.data.data[0].nature_of_business &&
            responseData.data.data[0].nature_of_business.value_code
              ? responseData.data.data[0].nature_of_business.value_code
              : null;
          this.editedProfile.source_of_fund_code =
            responseData.data.data[0].source_of_fund_code &&
            responseData.data.data[0].source_of_fund_code.value_code
              ? responseData.data.data[0].source_of_fund_code.value_code
              : null;

          this.editedProfile.mailing_country =
            responseData.data.data[0].mailing_country &&
            responseData.data.data[0].mailing_country.iso_alpha3
              ? responseData.data.data[0].mailing_country.iso_alpha3
              : null;
          if (
            responseData.data.data[0].mailing_country &&
            responseData.data.data[0].mailing_country.iso_alpha3
          ) {
            this.getMailingStates(
              responseData.data.data[0].mailing_country.iso_alpha3
            );
            if (this.editedProfile.mailing_state) {
              this.editedProfile.mailing_state =
                responseData.data.data[0].mailing_state &&
                responseData.data.data[0].mailing_state.state_code
                  ? responseData.data.data[0].mailing_state.state_code
                  : null;
              this.getCities(
                responseData.data.data[0].mailing_country.iso_alpha3,
                responseData.data.data[0].mailing_state.state_code,
                false,
                responseData.data.data[0].mailing_city?.name
              );
              this.editedProfile.mailing_city =
                responseData.data.data[0].mailing_city &&
                responseData.data.data[0].mailing_city.id
                  ? responseData.data.data[0].mailing_city.id
                  : null;
            }
          }
          this.editedProfile.country_code =
            responseData.data.data[0].country_code &&
            responseData.data.data[0].country_code.iso_alpha3
              ? responseData.data.data[0].country_code.iso_alpha3
              : null;
          if (this.editedProfile.country_code) {
            this.getStates(responseData.data.data[0].country_code.iso_alpha3);
            if (this.editedProfile.state_code) {
              this.editedProfile.state_code =
                responseData.data.data[0].state_code &&
                responseData.data.data[0].state_code.state_code
                  ? responseData.data.data[0].state_code.state_code
                  : null;
              this.getMailingCities(
                this.editedProfile.country_code,
                this.editedProfile.state_code,
                false,
                responseData.data.data[0].city_code?.name
              );
              this.editedProfile.city_code =
                responseData.data.data[0].city_code &&
                responseData.data.data[0].city_code.id
                  ? responseData.data.data[0].city_code.id
                  : null;
            }
          }
        } else {
          this.editedProfile = {};
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    closeDialog() {
      this.dialog = false;
      this.$refs.Addform.resetValidation();
    },

    EditProfileData() {
      this.dialog = true;
      this.getBusinessInfo();
    },

    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        this.save();
      }
    },
    async save() {
      console.log(this.editedProfile);
      this.loader = true;
      try {
        const responseData = await businessService.updateEntityDetails(
          this.editedProfile,
          {
            customer_id: this.$route.query.id,
          }
        );
        if (responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
          this.dialog = false;
          this.loader = false;
          this.getBusinessInfoData();
          console.log("update", responseData);
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
      } catch (error) {
        console.error(error);
        this.loader = false;
      }
    },
    async getdropdowntypes(code) {
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          switch (code) {
            case "SOF":
              console.log("SOF codes", response.data.data);
              this.SourceOfFunds = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
            case "NOB":
              console.log("NOB codes", response.data.data);
              this.NatureOfBusiness = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
            case "ETD":
              console.log("ETD codes", response);
              this.EntityTypes = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
          }
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.CountryOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.iso_alpha3 };
          });
        }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryOptions = [];
      }
    },
    async getStates(country_code) {
      try {
        const response = await commonService.getStatesList(country_code);
        if (response.status === 200) {
          this.stateOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.state_code };
          });
          if (
            this.editedProfile.state_code &&
            this.editedProfile.state_code.state_code
          ) {
            this.editedProfile.state_code =
              this.editedProfile.state_code.state_code;
          }
        } else {
          this.stateOptions = [];
        }

        console.log("States", response);
      } catch (e) {
        this.dropdown.state_options = [];
        console.error(e);
      }
    },
    async getCities(country_code, state_code, resetSelection = false, existingCityName = null) {
      if (resetSelection) this.editedProfile.mailing_city = "";
      this.mailingCityInputEnabled = false;
      this.cityOptions = [];
      try {
        const response = await commonService.getCitiesList(
          country_code,
          state_code
        );
        console.log("cities", response);
        if (response.status === 200) {
          this.cityOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.id, id: i.id };
          });
          this.mailingCityInputEnabled = this.cityOptions.length === 0;
          if (this.mailingCityInputEnabled && existingCityName) {
            this.editedProfile.mailing_city = existingCityName;
          }
        } else {
          this.cityOptions = [];
        }
        console.log("company_city", response);
      } catch (error) {
        this.cityOptions = [];
        console.error("Error fetching :", error);
      }
    },

    async getMailingStates(country_code) {
      try {
        const response = await commonService.getStatesList(country_code);
        if (response.status === 200) {
          this.mailingStateOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.state_code };
          });
          // if (
          //   this.editedProfile.mailing_state &&
          //   this.editedProfile.mailing_state.state_code
          // ) {
          //   this.editedProfile.mailing_state =
          //     this.editedProfile.mailing_state.state_code;
          // }
        } else {
          this.mailingStateOptions = [];
        }

        console.log("States", response);
      } catch (e) {
        this.mailingStateOptions = [];
        console.error(e);
      }
    },

    async getMailingCities(country_code, state_code, resetSelection = false, existingCityName = null) {
      if (resetSelection) this.editedProfile.city_code = "";
      this.businessCityInputEnabled = false;
      this.mailingCityOptions = [];
      try {
        const response = await commonService.getCitiesList(
          country_code,
          state_code
        );
        console.log("cities", response);
        if (response.status === 200) {
          this.mailingCityOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.id, id: i.id };
          });
          this.businessCityInputEnabled = this.mailingCityOptions.length === 0;
          if (this.businessCityInputEnabled && existingCityName) {
            this.editedProfile.city_code = existingCityName;
          }
        } else {
          this.mailingCityOptions = [];
        }
        console.log("company_city", response);
      } catch (error) {
        this.mailingCityOptions = [];
        console.error("Error fetching :", error);
      }
    },
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.upload-btn {
  position: absolute !important;
  z-index: 999;
  top: 135px;
  color: cadetblue;
  background: blueviolet;
  background: rgb(125, 198, 163);
  background: linear-gradient(
    50deg,
    rgba(125, 198, 163, 1) 0%,
    rgba(35, 216, 227, 1) 72%
  );
}

.avatar-shadow {
  box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -moz-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
}
.image_style {
  max-height: 260px;
  max-width: 260px;
  border: 1px solid rgb(210, 208, 208);
}

table {
  font-family: "Open Sans", sans-serif;
  border: none;
  width: 100%;

  tbody {
    td {
      text-align: left;
      padding: 3px;
      vertical-align: middle;
      font-size: 15px;
      font-weight: normal;
      border: none;
      margin: 5px;
    }
  }
}

label {
  font-size: 15px;
  color: black;
}
.required:after {
  content: " *";
  color: red;
}
</style>
